import React, { useState } from "react";
import { toast } from "sonner";
import { Gift, Sparkles, Zap, Globe2 } from "lucide-react";
import { callAdmin } from "./shared";
import { useAuth } from "../../lib/auth";

const box = "rounded-xl border border-[#39194D] bg-[#12082B] p-4 space-y-3";
const btn = "px-3 py-1.5 rounded-lg border font-heading text-xs uppercase tracking-widest transition-colors disabled:opacity-50";

// Handshake gifts: delivered as claimable private messages.
export function GiftPanel({ selected }) {
  const [amount, setAmount] = useState(100);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (target) => {
    if (target !== "player" && !window.confirm(`Send ${amount} Handshakes to ${target === "all" ? "EVERY player" : "all online players"}?`)) return;
    setBusy(true);
    const r = await callAdmin("post", "/gifts", { target, amount: Number(amount), note, user_id: selected?.user_id });
    setBusy(false);
    if (r) window.dispatchEvent(new CustomEvent("admin-log-refresh"));
    if (r) toast.success(`Gift sent to ${r.recipients} player(s)`);
  };
  return (
    <div className={box} data-testid="admin-gift-panel">
      <div className="font-heading text-sm neon-cyan flex items-center gap-2"><Gift size={16} /> Handshake gifts</div>
      <div className="flex flex-wrap gap-2 items-center">
        <input data-testid="gift-amount" type="number" min={1} max={100000} value={amount} onChange={(e) => setAmount(e.target.value)}
          className="w-28 px-2 py-1.5 rounded-lg bg-[#0A051A] border border-[#00F0FF]/40 font-mono text-xs" />
        <input data-testid="gift-note" value={note} maxLength={200} onChange={(e) => setNote(e.target.value)} placeholder="Message (optional)"
          className="flex-1 min-w-[160px] px-2 py-1.5 rounded-lg bg-[#0A051A] border border-[#00F0FF]/40 font-mono text-xs" />
      </div>
      <div className="flex flex-wrap gap-2">
        <button data-testid="gift-online-btn" disabled={busy} onClick={() => send("online")} className={`${btn} border-[#39FF14] text-[#39FF14] hover:bg-[#39FF14]/15`}>All online players</button>
        <button data-testid="gift-all-btn" disabled={busy} onClick={() => send("all")} className={`${btn} border-[#FF007F] text-[#FF007F] hover:bg-[#FF007F]/15`}>Every player</button>
        <button data-testid="gift-player-btn" disabled={busy || !selected} onClick={() => send("player")} className={`${btn} border-[#00F0FF] text-[#00F0FF] hover:bg-[#00F0FF]/15`}>
          {selected ? `Only ${selected.account_name}` : "Pick a player below"}
        </button>
      </div>
    </div>
  );
}

// Dev/test helpers for the admin's own account (moved from the bottom menu).
export function CheatPanel() {
  const { refresh } = useAuth();
  const run = async (kind, msg) => { if (await callAdmin("post", `/cheats/${kind}`, {}, msg)) refresh(); };
  return (
    <div className={box} data-testid="admin-cheat-panel">
      <div className="font-heading text-sm neon-cyan">Test tools (your account)</div>
      <div className="flex flex-wrap gap-2">
        <button data-testid="cheat-handshakes-btn" onClick={() => run("handshakes", "+1,000 Handshakes")} className={`${btn} border-[#00F0FF] text-[#00F0FF] hover:bg-[#00F0FF]/15 flex items-center gap-1`}><Sparkles size={14} /> +1k Handshakes</button>
        <button data-testid="cheat-pyro-energy-btn" onClick={() => run("pyro-energy", "+5 Pyro Energy")} className={`${btn} border-[#FFD700] text-[#FFD700] hover:bg-[#FFD700]/15 flex items-center gap-1`}><Zap size={14} /> +5 Pyro Energy</button>
        <button data-testid="cheat-tour-fans-btn" onClick={() => run("tour-fans", "+100,000 of every Tour fan currency")} className={`${btn} border-[#39FF14] text-[#39FF14] hover:bg-[#39FF14]/15 flex items-center gap-1`}><Globe2 size={14} /> +100k Tour fans</button>
      </div>
    </div>
  );
}
